module.exports = __webpack_public_path__ + "static/media/bg-orange.d7e2ad28.png";